module.exports = __webpack_public_path__ + "img/hqm.1a60926a.png";